export const phoneNumberWithOrWithoutCountryCodeRegex = /^\+?[01]?[- .]?(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;
export const phoneNumberWithoutCountryCodeRegex = /^(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;





